import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledIntegrationTag } from "../styles";

export const StyledNotConnectedTag = styled(StyledIntegrationTag)`
    background-color: ${colorsPalettes.indigo["100"]};

    & span {
        color: ${colorsPalettes.indigo["500"]};
    }
`;
